module.exports = __webpack_public_path__ + "img/atomic_02.a4773caf.png";